import { useCallback } from 'react';
import useAPI from './useApi';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const useTradeChecklist = () => {
  const { request } = useAPI();

  const getTradeChecklist = useCallback(() => {
    const url = `${BACKEND_URL}/trade_checklist`;
    return request(url, {}, 'GET');
  }, [request]);

  const saveTradeChecklist = useCallback((payload) => {
    const url = `${BACKEND_URL}/trade_checklist`;
    return request(url, {}, 'PUT', payload);
  }, [request]);

  const createTradeChecklistEntry = useCallback((payload) => {
    const url = `${BACKEND_URL}/trade_checklist_entries`;
    return request(url, {}, 'POST', payload);
  }, [request]);

  const getTradeChecklistEntries = useCallback((params = {}) => {
    const qs = new URLSearchParams();
    if (params.account_id) qs.set('account_id', params.account_id);
    if (params.trade_id) qs.set('trade_id', params.trade_id);
    if (params.limit) qs.set('limit', String(params.limit));
    const query = qs.toString();
    const url = `${BACKEND_URL}/trade_checklist_entries${query ? `?${query}` : ''}`;
    return request(url, {}, 'GET');
  }, [request]);

  const updateTradeChecklistEntry = useCallback((id, payload) => {
    const url = `${BACKEND_URL}/trade_checklist_entries/${id}`;
    return request(url, {}, 'PUT', payload);
  }, [request]);

  return {
    getTradeChecklist,
    saveTradeChecklist,
    createTradeChecklistEntry,
    getTradeChecklistEntries,
    updateTradeChecklistEntry,
  };
};
